import React, { useContext, useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../../../config/AuthContext";
import { Content } from "antd/es/layout/layout";
import { Table, Button, Space, Avatar, Progress, Dropdown, Tag, Row, Col, Card, Tooltip, Badge, Typography, Divider, Modal, Alert, Input, message } from "antd";
import { FaArrowRight, FaHandPaper, FaInfoCircle, FaTasks, FaFileExcel, FaChartBar, FaChartLine } from "react-icons/fa";
import { GiCancel } from "react-icons/gi";
import { BiChat, BiGroup } from "react-icons/bi";
import { DownOutlined } from "@ant-design/icons";
import DudaTextoModal from "./DudaTextoModal";
import AulaStatsModal from "./AulaStatsModal";
import ChatModal from "../../jutge/components/ChatModal";
import AulaModal from "../AulaModal";
import LoadingSkeleton from "../LoadingSkeleton";
import HomeColors from "../../../styles/HomeColors";
import { GetAllAules } from "../../../dao/GetAllAules";
import { GetAlumneId } from "../../../dao/GetAlumneId";
import { PostDuda } from "../../../dao/PostDuda";
import { DeleteDuda } from "../../../dao/DeleteDuda";
import { DeleteQuestion } from "../../../dao/jutge/DeleteQuestion";
import { GetInteraccionsId } from "../../../dao/GetInteraccionsId";
import items from "../../jutge/problemesId/content/SortirCuaArray";
import itemsIA from "../../jutge/problemesId/content/SortirCuaArrayIA";
import { FaPencil } from "react-icons/fa6";
import { FaLock, FaUnlock } from "react-icons/fa";
import { PiExam } from "react-icons/pi";
import { motion } from "framer-motion";
import ChatTableModal from "../../jutge/components/ChatTableModal";
import { PostDudaCompany } from "../../../dao/PostDudaCompany";
import '../../../css/home.css';
import CuaModal from "../../jutge/components/CuaModal";
import { GrConfigure, GrDocumentConfig } from "react-icons/gr";
import UseWebSocketSubscription from "../../UseWebSocketSubscription";
import { GetAulaIdConfiguracio } from "../../../dao/GetAulaIdConfiguracio";
import RaModal from "../RaModal";
import AulaStudentsModal from "../AulaStudentsModal";
import AulaImportModal from "../AulaImportModal";
import NotesResumModal from "../NotesResumModal";
import { GetSceneActivities } from "../../../dao/jutge/GetJavamonConfig";
import { ToggleAulaBloqueoFoco } from "../../../dao/ToggleAulaBloqueoFoco";
import { ToggleAulaIsExamen } from "../../../dao/ToggleAulaIsExamen";

const Welcome = () => {
    const { isLoggedIn, userId, user, userPermisos, setBreadCrumb, alumne, setAlumneInfo } = useContext(AuthContext);
    const navigate = useNavigate();
    const { id } = useParams();
    const [dades, setDades] = useState<any[]>([]);
    const [projectes, setProjectes] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [loadingEditar, setLoadingEditar] = useState(false);
    const [torns, setTorns] = useState<Record<string, any>>({});
    const [modalVisible, setModalVisible] = useState(false);
    const [modalAula, setModalAula] = useState<string | null>(null);
    const [copypaste, setIsCopypaste] = useState();
    const [editarAula, setEditarAula] = useState(false);
    const [buttonLoading, setButtonLoading] = useState(false);
    const [conversaModal, setConversaModal] = useState(false);
    const [dubtesModal, setDubtesModal] = useState(false);
    const [isColab, setIsColab] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);
    const [chatVisible, setChatVisible] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState<any | null>(null);
    const [selectedAula, setSelectedAula] = useState<any | null>(null);
    const [modalRA, setModalRA] = useState(false);
    const [json, setJson] = useState<any>();
    const [studentModalVisible, setStudentModalVisible] = useState(false);
    const [importModalVisible, setImportModalVisible] = useState(false);
    const [statsVisible, setStatsVisible] = useState(false);
    const [profRequests, setProfRequests] = useState<any[]>([]);
    const [exitedAi, setExitedAi] = useState<string[]>([]);
    const [notesResumVisible, setNotesResumVisible] = useState(false);
    const [notesResumAula, setNotesResumAula] = useState<any | null>(null);
    const [inscriuModalVisible, setInscriuModalVisible] = useState(false);
    const [codiAula, setCodiAula] = useState("");
    const [inscriuLoading, setInscriuLoading] = useState(false);
    const [aulasAmbJoc, setAulasAmbJoc] = useState<number[]>([]);

    const playBeep = () => {
        try {
            const AudioContext = window.AudioContext || (window as any).webkitAudioContext;
            if (!AudioContext) return;
            const ctx = new AudioContext();
            const osc = ctx.createOscillator();
            const gain = ctx.createGain();
            osc.connect(gain);
            gain.connect(ctx.destination);
            osc.type = "sine";
            osc.frequency.value = 523.25; // C5
            gain.gain.value = 0.1;
            osc.start();
            setTimeout(() => {
                osc.stop();
                ctx.close();
            }, 400);
        } catch (e) {
            console.error("Audio play failed", e);
        }
    };

    useEffect(() => {
        if (!dades) return;
        const hasDoubts = dades.some((aula: any) =>
            aula?.dudas === 1 && aula?.dubtes?.length > 0
        );
        if (hasDoubts && (user.tipus === "1" || user.tipus === "0")) {
            playBeep();
        }
    }, [dades]);

    useEffect(() => {
        if (isLoggedIn) {
            checkDades();
            setBreadCrumb([{ nom: 'Home', nav: '/home' }], true);

            //setIntervalCheckDades();
            //return () => deleteRefresh();
        }
    }, [id, isColab, copypaste]);

    UseWebSocketSubscription(["/topic/home"], (topic, msg) => {
        console.log(`Mensaje en ${topic}:`, msg);
        if (msg === true || msg.accion === "REFRESH") {
            checkDades(false);
        }
    });

    /*function deleteRefresh() {
        if (interval?.current) clearInterval(interval.current);
        if (interval2?.current) clearInterval(interval2.current);
        const interval_id = window.setInterval(function(){}, Number.MAX_SAFE_INTEGER);

        for (let i = 1; i < interval_id; i++) {
            window.clearInterval(i);
        }
    }
    */

    async function checkDades(refresh: boolean = true) {
        setLoading(refresh);
        const alumneData = await GetAlumneId(userId);
        const result = alumneData?.aules || [];
        const proj = alumneData?.projectes || [];

        setAlumneInfo(alumneData);
        setDades(result);
        setProjectes(proj);

        const activeCuaAulaIds = result.filter((a: any) => a.cua).map((a: any) => String(a.id));
        setProfRequests(prev => prev.filter(id => activeCuaAulaIds.includes(String(id))));
        setExitedAi(prev => prev.filter(id => activeCuaAulaIds.includes(String(id))));

        try {
            const activities = await GetSceneActivities();
            if (activities && activities.length > 0) {
                const uniqueAulas = Array.from(new Set(activities.map((a: any) => a.id_aula)));
                setAulasAmbJoc(uniqueAulas as number[]);
            }
        } catch (e) {
            console.error("Error fetching scene activities", e);
        }

        setTorns(prev => {
            const newTorns = { ...prev };
            let hasChanges = false;
            result.forEach((aula: any) => {
                const backendEnCua = Boolean(aula.cua);
                if (newTorns[aula.id] && newTorns[aula.id].enCua !== backendEnCua) {
                    newTorns[aula.id] = { ...newTorns[aula.id], enCua: backendEnCua };
                    hasChanges = true;
                }
            });
            return hasChanges ? newTorns : prev;
        });

        setLoading(false);
        setLoadingEditar(false);
        if (!dubtesModal) setButtonLoading(false);
    }

    const isBloqueoFocoActive = (aula: any) => {
        return aula.bloqueoFoco === undefined ? true : Boolean(aula.bloqueoFoco === 1 || aula.bloqueoFoco === true || aula.bloqueo_foco === 1 || aula.bloqueo_foco === true);
    };

    const handleToggleBloqueoFoco = async (aula: any) => {
        const currentlyActive = isBloqueoFocoActive(aula);
        const nextState = !currentlyActive;
        // Optimistic update local
        setDades(prev => prev.map(a => a.id === aula.id ? { ...a, bloqueoFoco: nextState, bloqueo_foco: nextState } : a));
        try {
            await ToggleAulaBloqueoFoco(aula.id, nextState);
            message.success(`Bloqueig de focus ${nextState ? 'activat 🛡️' : 'desactivat 🔓'} per a l'aula ${aula.nom || aula.id}`);
        } catch (e) {
            console.error("Error toggling bloqueo foco:", e);
            message.error("Error al canviar l'estat del bloqueig de focus");
            checkDades(false);
        }
    };

    const isExamenAulaActive = (aula: any) => {
        return Boolean(aula.isExamen === 1 || aula.isExamen === true || aula.is_examen === 1 || aula.is_examen === true);
    };

    const handleToggleIsExamen = async (aula: any) => {
        const currentlyActive = isExamenAulaActive(aula);
        const nextState = !currentlyActive;
        // Optimistic update local
        setDades(prev => prev.map(a => a.id === aula.id ? { ...a, isExamen: nextState ? 1 : 0, is_examen: nextState ? 1 : 0 } : a));
        try {
            await ToggleAulaIsExamen(aula.id, nextState);
            message.success(`Mode examen ${nextState ? 'ACTIVAT 📝' : 'desactivat'} per a l'aula ${aula.nom || aula.id}`);
        } catch (e) {
            console.error("Error toggling mode examen:", e);
            message.error("Error al canviar l'estat del mode examen");
            checkDades(false);
        }
    };

    /*function setIntervalCheckDades() {
        if (interval2.current) clearInterval(interval2.current);
        interval2.current = setInterval(async () => await checkDades(false), 3000);
    }*/

    async function entrarEnCua(aulaId: string, text: string = "-1") {
        setTorns(prev => ({ ...prev, [aulaId]: { ...prev[aulaId], loading: true } }));
        let torn = {};
        torn = await PostDuda(aulaId, userId, text, 0, 0, 0);
        setTorns(prev => ({ ...prev, [aulaId]: { ...torn, loading: false, enCua: true, id_aula: aulaId } }));
        await checkDades(false);
    }

    async function sortirDeCua(aula: any, estat: number) {
        if (profRequests.includes(String(aula.id))) {
            setExitedAi(prev => [...prev, String(aula.id)]);
        } else {
            setProfRequests(prev => prev.filter(id => String(id) !== String(aula.id)));
            setExitedAi(prev => prev.filter(id => String(id) !== String(aula.id)));
        }
        setTorns(prev => ({ ...prev, [aula.id]: { ...prev[aula.id], loading: true } }));
        let torn = {};
        if (aula.ia === 1 || aula.colab === 1) {
            torn = await DeleteQuestion(aula.id, userId, estat, aula.id_dubte + "", "0", "0");
            await DeleteDuda(aula.id, userId, estat);
        } else {
            torn = await DeleteDuda(aula.id, userId, estat);
        }
        // Reset immediately in local state so enCua doesn't stay truthy from aula.cua
        setTorns(prev => ({ ...prev, [aula.id]: { ...torn, enCua: false, loading: false } }));
        setDades(prev => prev.map((a: any) => a.id === aula.id ? { ...a, cua: null, id_dubte: null } : a));
        await checkDades(false);
    }

    async function inscriureAula() {
        if (!codiAula.trim()) return;
        setInscriuLoading(true);
        try {
            const url = process.env.REACT_APP_API_URL + ':8061/aules/inscriure';
            const res = await fetch(url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ userId: userId, codi: codiAula.trim() })
            });
            if (res.ok) {
                setInscriuModalVisible(false);
                setCodiAula("");
                await checkDades(true);
            } else {
                const data = await res.json().catch(() => null);
                Modal.error({
                    title: 'Error d\'inscripció',
                    content: data?.message || "No s'ha trobat cap aula amb aquest codi o ja hi estàs inscrit."
                });
            }
        } catch (e) {
            console.error(e);
            Modal.error({ title: 'Error', content: 'No s\'ha pogut connectar amb el servidor' });
        } finally {
            setInscriuLoading(false);
        }
    }

    if (!isLoggedIn) {
        navigate("/login");
        return null;
    }

    async function checkChat(id_aula: any, id_dubte: any) {
        const record = await GetInteraccionsId(userId + "", id_dubte + "");
        setSelectedRecord({ ...record, id_aula: id_aula });
        setChatVisible(true);
        /*
        deleteRefresh();
        if (interval.current) clearInterval(interval.current);
                interval.current = setInterval(async () => {
                    const refreshed = await GetInteraccionsId(userId + "", id_dubte + "");
                    setSelectedRecord(refreshed);
                }, 3000);*/
        //setIntervalCheckDades();
    }

    function closeModal() {
        setChatVisible(false);
        checkDades(false);
    }

    const normalizeImg = (img?: string | null) => {
        if (!img || img === "undefined" || img === "null") return "/images/default.png";
        if (img === "avatar1.jpg") return "/images/avatar1.jpg";
        if (img.startsWith("http") || img.startsWith("data:") || img.startsWith("/")) return img;
        if (img.endsWith(".jpg") || img.endsWith(".png") || img.endsWith(".jpeg") || img.endsWith(".svg")) return `/images/${img}`;
        if (img.startsWith("base64:")) img = img.split(":").pop()!;
        if (img.startsWith("/9j/")) return `data:image/jpeg;base64,${img}`;
        if (img.startsWith("iVB")) return `data:image/png;base64,${img}`;
        return `data:image/png;base64,${img}`;
    };

    const sortedAules = dades.slice().sort((a, b) => {
        const aTotal = (a.dubtes?.length || 0) + (a.conversa?.length || 0);
        const bTotal = (b.dubtes?.length || 0) + (b.conversa?.length || 0);

        // Si ambos tienen 0, ordenamos por id ascendente
        if (aTotal === 0 && bTotal === 0) return b.id - a.id;

        // Si uno de los dos tiene 0, ponemos el que tiene >0 primero
        if (aTotal === 0) return 1;
        if (bTotal === 0) return -1;

        // Orden descendente normal por dubtes + conversa
        return bTotal - aTotal;
    });

    async function ajudarComanys(aula: any) {
        setSelectedAula(aula);
        setConversaModal(true);
    }

    async function gestioDubte(aula: any) {
        setSelectedAula(aula);
        setDubtesModal(true);
        setButtonLoading(true);
    }

    async function editarRA(ele: any) {
        //setLoading(true);
        setSelectedAula(ele);

        const data = await GetAulaIdConfiguracio(ele.id + "", 1);
        const formattedData = { items: data };
        setJson(formattedData);
        console.log(JSON.stringify(formattedData));

        setModalRA(true);
    }

    function onCloseRA(value: boolean) {
        if (value)
            checkDades();
        setModalRA(false);
        //setLoading(false);
    }


    const renderAulaActions = (aula: any) => {
        const torn = torns[aula.id] || {};
        const enCua = torn.enCua ?? Boolean(aula.cua);
        const personesDavant = (aula.torn ?? torn.torn ?? -1) - 1;
        const selectedItems = aula.ia === 1 ? itemsIA : items;

        return (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginTop: '16px' }}>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Space wrap>
                        {(user.tipus === "1" || user.tipus === "0") && (
                            <>
                                {aula?.dudas === 1 && aula?.ia !== 1 && aula?.dubtes?.length > 0 &&
                                    <motion.div animate={{ scale: [1, 1.05, 1], boxShadow: ["0 0 0 0 rgba(255,87,34,0.6)", "0 0 0 10px rgba(255,87,34,0)", "0 0 0 0 rgba(255,87,34,0)"] }} transition={{ duration: 1.5, repeat: Infinity }}>
                                        <Button icon={<FaInfoCircle />} style={{ backgroundColor: "coral", color: "white", borderRadius: '8px' }} disabled={aula?.dubtes?.length === 0} loading={torn.loading || buttonLoading} onClick={() => gestioDubte(aula)}>
                                            {`Tens ${aula?.dubtes?.length} dubte${aula?.dubtes?.length > 1 ? "s" : ""}!`}
                                        </Button>
                                    </motion.div>
                                }
                                {aula?.dudas === 1 && aula?.ia !== 1 && aula?.colab !== 1 && aula?.dubtes?.length === 0 &&
                                    <Tag color="cyan" style={{ borderRadius: '12px', padding: '4px 12px' }}>Aula sense dubtes ✨</Tag>
                                }
                                {aula?.ia === 1 && aula?.conversa?.length > 0 &&
                                    <motion.div animate={{ scale: [1, 1.05, 1], boxShadow: ["0 0 0 0 rgba(24,144,255,0.6)", "0 0 0 10px rgba(24,144,255,0)", "0 0 0 0 rgba(24,144,255,0)"] }} transition={{ duration: 1.5, repeat: Infinity }}>
                                        <Button icon={<BiChat />} type="primary" style={{ borderRadius: '8px' }} loading={buttonLoading} onClick={() => ajudarComanys(aula)}>
                                            {`${aula?.conversa?.length} conversa${aula?.conversa?.length > 1 ? "s" : ""} IA`}
                                        </Button>
                                    </motion.div>
                                }
                                {aula?.ia === 1 && (!aula?.conversa || aula?.conversa?.length === 0) &&
                                    <Button icon={<BiChat />} type="primary" style={{ borderRadius: '8px' }} loading={buttonLoading} onClick={() => ajudarComanys(aula)}>
                                        0 converses IA
                                    </Button>
                                }
                                {aula?.ia === 1 && aula?.dudas === 1 && aula?.dubtes?.length > 0 &&
                                    <motion.div animate={{ scale: [1, 1.05, 1], boxShadow: ["0 0 0 0 rgba(255,87,34,0.6)", "0 0 0 10px rgba(255,87,34,0)", "0 0 0 0 rgba(255,87,34,0)"] }} transition={{ duration: 1.5, repeat: Infinity }}>
                                        <Button icon={<FaInfoCircle />} style={{ backgroundColor: "coral", color: "white", borderRadius: '8px' }} disabled={aula?.dubtes?.length === 0} loading={torn.loading || buttonLoading} onClick={() => gestioDubte(aula)}>
                                            {`Cua: ${aula?.dubtes?.length} dubte${aula?.dubtes?.length > 1 ? "s" : ""}!`}
                                        </Button>
                                    </motion.div>
                                }
                                {aula?.ia === 1 && aula?.dudas === 1 && aula?.dubtes?.length === 0 &&
                                    <Tag color="cyan" style={{ borderRadius: '12px', padding: '4px 12px' }}>Cua buida ✨</Tag>
                                }
                            </>
                        )}

                        {(aula?.dudas === 1 || aula?.ia === 1) && !enCua && user.tipus === "2" && (
                            <Button type="primary" icon={<FaHandPaper />} style={{ backgroundColor: HomeColors.colors.color4, borderColor: HomeColors.colors.color4, borderRadius: '8px' }} loading={torn.loading} onClick={() => {
                                if (aula.ia === 1 || aula.colab === 1) {
                                    setModalAula(aula.id);
                                    setIsCopypaste(aula.copypaste);
                                    setModalVisible(true);
                                    setIsColab(aula.colab === 1 && aula.ia !== 1);
                                } else entrarEnCua(aula.id);
                            }}>Demanar ajuda</Button>
                        )}

                        {aula?.colab === 1 && aula?.conversa?.length > 0 && user.tipus === "2" && Boolean(aula?.dudas) && (
                            <motion.div animate={{ scale: [1, 1.05, 1], boxShadow: ["0 0 0 0 rgba(255,87,34,0.6)", "0 0 0 10px rgba(255,87,34,0)", "0 0 0 0 rgba(255,87,34,0)"] }} transition={{ duration: 1.5, repeat: Infinity }}>
                                <Button icon={<FaInfoCircle />} style={{ backgroundColor: "coral", color: "white", border: "none", fontWeight: 600, borderRadius: '8px' }} onClick={() => ajudarComanys(aula)}>Ajudar Companys/es</Button>
                            </motion.div>
                        )}

                        {(aula?.dudas === 1 || aula?.ia === 1) && enCua && (
                            <Space wrap>
                                <Tag color="processing" style={{ padding: '6px 12px', borderRadius: '8px', fontSize: '14px' }}>
                                    {personesDavant > 0 ? `⏳ ${personesDavant} persones davant` : `🚀 Ets el/la següent!`}
                                </Tag>
                                {!exitedAi.includes(String(aula.id)) && (
                                    <Dropdown menu={{ items: selectedItems, onClick: (e) => sortirDeCua(aula, -1 - parseInt(e.key)) }}>
                                        <Button icon={<GiCancel />} loading={torn.loading} danger style={{ borderRadius: '8px' }}>Sortir <DownOutlined /></Button>
                                    </Dropdown>
                                )}
                                {!exitedAi.includes(String(aula.id)) && Boolean((aula.ia === 1 || aula.colab === 1)) && (
                                    <Button icon={<BiChat />} type="primary" style={{ backgroundColor: aula?.newchat ? "lightcoral" : HomeColors.colors.color5, borderRadius: '8px' }} onClick={() => checkChat(aula.id, aula.id_dubte)}>
                                        Conversa
                                    </Button>
                                )}
                            </Space>
                        )}

                        {Boolean(aula.jocHabilitat === 1 || aula.jocHabilitat === true || aula.joc_habilitat === 1 || aula.joc_habilitat === true) && 
                         !(isExamenAulaActive(aula) && (user.tipus !== "0" && user.tipus !== "1")) && (
                            <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
                                <Button
                                    type="primary"
                                    style={{ backgroundColor: '#8a2be2', borderColor: '#8a2be2', borderRadius: '8px', fontWeight: 'bold' }}
                                    onClick={() => {
                                        const ticket = Date.now().toString();
                                        localStorage.setItem('pending_game_aulaId', String(aula.id));
                                        localStorage.setItem('game_launch_ticket', ticket);
                                        window.open(`/game?ticket=${ticket}`, '_blank');
                                    }}
                                >
                                    ✨ Iniciar Aventura ✨
                                </Button>
                            </motion.div>
                        )}
                    </Space>
                </div>

                <Divider style={{ margin: '8px 0' }} />

                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', justifyContent: 'flex-end' }}>
                    {(user.tipus === "1" || user.tipus === "0") && (
                        <Space wrap>
                            <Tooltip title={isBloqueoFocoActive(aula) ? "Desactivar Bloqueig de Focus (en viu)" : "Activar Bloqueig de Focus (en viu)"}>
                                <Button
                                    icon={isBloqueoFocoActive(aula) ? <FaLock /> : <FaUnlock />}
                                    type={isBloqueoFocoActive(aula) ? "primary" : "default"}
                                    danger={!isBloqueoFocoActive(aula)}
                                    shape="circle"
                                    onClick={() => handleToggleBloqueoFoco(aula)}
                                />
                            </Tooltip>
                            <Tooltip title={isExamenAulaActive(aula) ? "Desactivar Mode Examen (en viu)" : "Activar Mode Examen (en viu - oculta pràctiques i activitats als alumnes)"}>
                                <Button
                                    icon={<PiExam size={18} />}
                                    type={isExamenAulaActive(aula) ? "primary" : "default"}
                                    danger={isExamenAulaActive(aula)}
                                    shape="circle"
                                    onClick={() => handleToggleIsExamen(aula)}
                                />
                            </Tooltip>
                            <Tooltip title="Tasques">
                                <Button icon={<FaTasks />} type="default" shape="circle" onClick={() => navigate(`/home/aules/${aula.id}`)} />
                            </Tooltip>
                            <Tooltip title="Resum de Notas">
                                <Button icon={<FaChartLine />} type="default" shape="circle" onClick={() => { setNotesResumAula(aula); setNotesResumVisible(true); }} />
                            </Tooltip>
                            <Tooltip title="Estadístiques">
                                <Button icon={<FaChartBar />} type="default" shape="circle" onClick={() => { setSelectedAula(aula); setStatsVisible(true); }} />
                            </Tooltip>
                            <Tooltip title="Configuració">
                                <Button icon={<FaPencil />} type="default" shape="circle" onClick={() => { setSelectedAula(aula); setEditarAula(true); }} />
                            </Tooltip>
                            <Tooltip title="Gestionar Alumnes">
                                <Button icon={<BiGroup />} type="default" shape="circle" onClick={() => { setSelectedAula(aula); setStudentModalVisible(true); }} />
                            </Tooltip>
                            <Tooltip title="Importar Usuaris">
                                <Button icon={<FaFileExcel />} type="default" shape="circle" onClick={() => { setSelectedAula(aula); setImportModalVisible(true); }} />
                            </Tooltip>
                        </Space>
                    )}
                    {(user.tipus === "0" || userId === "2") && (
                        <Tooltip title="Configuració RAs">
                            <Button icon={<GrDocumentConfig />} type="default" shape="circle" onClick={() => editarRA(aula)} />
                        </Tooltip>
                    )}
                </div>
            </div>
        );
    };

    const renderActivities = (aula: any) => {
        const canSeeJutge = user.tipus === "0" || user.tipus === "2" || userPermisos.some(p => p.accio?.includes("/jutge"));
        const canSeeBBDD = user.tipus === "0" || user.tipus === "2" || userPermisos.some(p => p.accio?.includes("/database"));
        const canSeeABP = user.tipus === "0" || user.tipus === "2" || userPermisos.some(p => p.accio?.includes("/abp"));

        const isExamMode = isExamenAulaActive(aula);
        const isStudent = user.tipus !== "0" && user.tipus !== "1";

        let allActivities = [
            ...(canSeeJutge ? (aula.jutge || []) : []).map((a: any) => ({ ...a, type: 'jutge', key: `j-${a.id}` })),
            ...(canSeeBBDD ? (aula.bbdd || []) : []).map((a: any) => ({ ...a, type: 'bbdd', key: `b-${a.id}` })),
            ...(canSeeABP ? (aula.activitats || []) : []).map((a: any) => ({ ...a, type: 'activitats', key: `a-${a.id}` }))
        ];

        if (isExamMode && isStudent) {
            allActivities = allActivities.filter((a: any) => (a.is_examen === 1 || a.is_examen === true || a.isExamen === 1 || a.isExamen === true) && (a.estat === 3 || a.estat === "3"));
        }

        allActivities.sort((a, b) => {
            const ordA = a.orden !== undefined && a.orden !== null ? a.orden : 0;
            const ordB = b.orden !== undefined && b.orden !== null ? b.orden : 0;
            if (ordA !== ordB) {
                return ordB - ordA; // Descending by orden
            }
            return b.id - a.id; // Descending by id
        });

        if (allActivities.length === 0) return null;

        const handleRowClick = (record: any) => {
            if (record.type === 'jutge') navigate(`/jutge/activitats/${record.id}`);
            if (record.type === 'bbdd') navigate(`/database/activitats/${record.id}`);
            if (record.type === 'activitats') navigate(`/home/aules/${record.id_aula}/projectes/${record.id}`);
        };

        const columns = [
            {
                title: 'Icona',
                dataIndex: 'imagen',
                key: 'imagen',
                width: 60,
                render: (_: any, record: any) => (
                    <Avatar
                        src={normalizeImg(record.imagen || record.img)}
                        shape="square"
                        size={36}
                        style={{ borderRadius: '8px', border: '1px solid #f0f0f0' }}
                    />
                )
            },
            {
                title: 'Nom',
                dataIndex: 'nom',
                key: 'nom',
                render: (text: string) => <Typography.Text strong style={{ color: '#495057', fontSize: '14px' }}>{text}</Typography.Text>
            },
            {
                title: 'Tipus',
                dataIndex: 'type',
                key: 'type',
                width: 100,
                render: (type: string) => {
                    if (type === 'jutge') return <Tag bordered={false} color="blue">Jutge</Tag>;
                    if (type === 'bbdd') return <Tag bordered={false} color="green">BBDD</Tag>;
                    if (type === 'activitats') return <Tag bordered={false} color="purple">Sessió</Tag>;
                    return <Tag bordered={false}>{type}</Tag>;
                }
            },
            {
                title: 'Acció',
                key: 'action',
                align: 'right' as const,
                width: 120,
                render: (_: any, record: any) => (
                    <Button
                        type="text"
                        size="small"
                        icon={<FaArrowRight style={{ color: HomeColors.colors.color4 }} />}
                        onClick={() => handleRowClick(record)}
                        style={{ color: HomeColors.colors.color4, fontWeight: 500, borderRadius: '6px' }}
                    >
                        Accedir
                    </Button>
                )
            }
        ];

        return (
            <div style={{ marginTop: '16px' }}>
                <Table
                    dataSource={allActivities}
                    columns={columns}
                    pagination={{ pageSize: 3, size: 'small', hideOnSinglePage: true }}
                    size="small"
                    showHeader={false}
                    rowKey="key"
                    style={{
                        border: '1px solid #f0f0f0',
                        borderRadius: '12px',
                        backgroundColor: '#fafafa',
                        overflow: 'hidden'
                    }}
                    rowClassName={() => 'custom-hover-row'}
                />
            </div>
        );
    };

    return (
        <Content style={{ padding: "24px", minHeight: 280, width: "100%", overflowX: "hidden", background: "#f0f2f5" }}>
            <motion.div initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
                <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: "16px", marginBottom: "32px", padding: '24px', background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.05)' }}>
                    <Avatar src={normalizeImg(alumne?.alumne?.avatar)} size={72} style={{ border: '3px solid #1890ff', padding: '2px', background: 'white' }} />
                    <div style={{ flex: 1 }}>
                        <Typography.Title level={2} style={{ margin: 0, fontWeight: 800, color: '#1f1f1f' }}>
                            Hola, <span style={{ color: '#1890ff' }}>{alumne?.alumne?.nom || ""}</span>! 👋
                        </Typography.Title>
                        <Typography.Text type="secondary" style={{ fontSize: '16px' }}>
                            Benvingut/da de nou al teu espai d'aprenentatge.
                        </Typography.Text>
                    </div>
                    {user.tipus === "1" && (
                        <Button type="primary" size="large" onClick={() => { setSelectedAula({ id: 0 }); setEditarAula(true); }} style={{ borderRadius: '8px', fontWeight: 600, background: 'linear-gradient(90deg, #1890ff, #0050b3)', border: 'none', boxShadow: '0 4px 15px rgba(24,144,255,0.4)' }}>
                            ✨ Crear Nova Aula
                        </Button>
                    )}
                    {user.tipus === "0" && (
                        <Button type="primary" size="large" icon={<GrConfigure />} onClick={() => navigate("/home/admin")} style={{ borderRadius: '8px', fontWeight: 600, background: 'linear-gradient(90deg, #ff4d4f, #cf1322)', border: 'none', boxShadow: '0 4px 15px rgba(255,77,79,0.4)' }}>
                            ⚙️ Gestió d'Admins
                        </Button>
                    )}
                    {user.tipus === "2" && (
                        <Button type="primary" size="large" onClick={() => setInscriuModalVisible(true)} style={{ borderRadius: '8px', fontWeight: 600, background: 'linear-gradient(90deg, #52c41a, #237804)', border: 'none', boxShadow: '0 4px 15px rgba(82,196,26,0.4)' }}>
                            📌 Inscriu-te a un aula
                        </Button>
                    )}
                </div>
            </motion.div>


            {loading ? (
                <LoadingSkeleton />
            ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '32px' }}>
                    {sortedAules.length > 0 && (
                        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5, delay: 0.2 }}>
                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px', gap: '8px' }}>
                                <Typography.Title level={3} style={{ margin: 0, fontWeight: 700 }}>Les teves Aules</Typography.Title>
                                <Badge count={sortedAules.length} style={{ backgroundColor: '#52c41a' }} />
                            </div>
                            <Row gutter={[24, 24]}>
                                {sortedAules.map((aula: any, index: number) => (
                                    <Col xs={24} sm={12} md={12} lg={8} xl={8} key={aula.id}>
                                        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4, delay: index * 0.1 }} style={{ height: '100%' }}>
                                            <Card
                                                hoverable
                                                style={{ height: '100%', borderRadius: '16px', border: '1px solid #e8e8e8', boxShadow: '0 8px 24px rgba(0,0,0,0.04)', overflow: 'hidden' }}
                                                styles={{ body: { padding: '20px', display: 'flex', flexDirection: 'column', height: '100%' } }}
                                            >
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                                    <Avatar src={normalizeImg(aula.img)} size={60} shape="square" style={{ borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }} />
                                                    <div style={{ flex: 1 }}>
                                                        <Typography.Title level={4} style={{ margin: 0, color: '#1f1f1f', fontWeight: 700 }}>
                                                            {aula.nom || "Sense nom"}
                                                        </Typography.Title>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginTop: '8px', flexWrap: 'wrap' }}>
                                                            <Tag color="blue" style={{ borderRadius: '12px', margin: 0 }}>Aula {aula.id}</Tag>
                                                            <Tooltip title={isBloqueoFocoActive(aula) ? "Bloqueig de focus ACTIU (antifrau)" : "Bloqueig de focus INACTIU"}>
                                                                <Tag
                                                                    color={isBloqueoFocoActive(aula) ? "success" : "default"}
                                                                    style={{
                                                                        borderRadius: '12px',
                                                                        margin: 0,
                                                                        cursor: (user.tipus === "1" || user.tipus === "0") ? 'pointer' : 'default',
                                                                        display: 'inline-flex',
                                                                        alignItems: 'center',
                                                                        gap: '4px'
                                                                    }}
                                                                    onClick={(e) => {
                                                                        if (user.tipus === "1" || user.tipus === "0") {
                                                                            e.stopPropagation();
                                                                            handleToggleBloqueoFoco(aula);
                                                                        }
                                                                    }}
                                                                >
                                                                    {isBloqueoFocoActive(aula) ? <FaLock size={11} /> : <FaUnlock size={11} />}
                                                                    {isBloqueoFocoActive(aula) ? "Focus Actiu" : "Sense Bloqueig"}
                                                                </Tag>
                                                            </Tooltip>
                                                            <Tooltip title={isExamenAulaActive(aula) ? "Mode Examen ACTIU: pràctiques i activitats no d'examen ocultes" : "Mode Examen INACTIU"}>
                                                                <Tag
                                                                    color={isExamenAulaActive(aula) ? "red" : "default"}
                                                                    style={{
                                                                        borderRadius: '12px',
                                                                        margin: 0,
                                                                        cursor: (user.tipus === "1" || user.tipus === "0") ? 'pointer' : 'default',
                                                                        display: 'inline-flex',
                                                                        alignItems: 'center',
                                                                        gap: '4px',
                                                                        fontWeight: isExamenAulaActive(aula) ? 700 : 400
                                                                    }}
                                                                    onClick={(e) => {
                                                                        if (user.tipus === "1" || user.tipus === "0") {
                                                                            e.stopPropagation();
                                                                            handleToggleIsExamen(aula);
                                                                        }
                                                                    }}
                                                                >
                                                                    <PiExam size={12} />
                                                                    {isExamenAulaActive(aula) ? "Mode Examen" : "Normal"}
                                                                </Tag>
                                                            </Tooltip>
                                                        </div>
                                                    </div>
                                                </div>

                                                {renderActivities(aula)}
                                                <div style={{ marginTop: 'auto' }}>
                                                    {renderAulaActions(aula)}
                                                </div>
                                            </Card>
                                        </motion.div>
                                    </Col>
                                ))}
                            </Row>
                        </motion.div>
                    )}

                    {(user.tipus === "0" || user.tipus === "2" || userPermisos.some(p => p.accio?.includes("/abp"))) && projectes && projectes.length > 0 && projectes[0].nom !== null && (
                        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5, delay: 0.4 }}>
                            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px', gap: '8px' }}>
                                <Typography.Title level={3} style={{ margin: 0, fontWeight: 700 }}>Els Teus Projectes</Typography.Title>
                                <Badge count={projectes.length} style={{ backgroundColor: '#1890ff' }} />
                            </div>
                            <Row gutter={[24, 24]}>
                                {projectes.map((proj: any, index: number) => {
                                    const estatColors: Record<number, { color: string, text: string, bg: string }> = {
                                        1: { color: '#52c41a', text: 'Obert', bg: '#f6ffed' },
                                        0: { color: '#8c8c8c', text: 'Tancat', bg: '#f5f5f5' },
                                        '-1': { color: '#ff4d4f', text: 'Eliminat', bg: '#fff2f0' },
                                        2: { color: '#faad14', text: 'Finalitzat', bg: '#fffbe6' }
                                    };
                                    const estat = estatColors[proj.estat] || { color: '#1890ff', text: 'Desconegut', bg: '#e6f7ff' };

                                    return (
                                        <Col xs={24} sm={12} md={8} lg={6} key={proj.id} style={{ display: 'flex' }}>
                                            <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.4, delay: index * 0.1 }} style={{ width: '100%' }}>
                                                <Card
                                                    hoverable={proj.estat !== 2}
                                                    onClick={() => { if (proj.estat !== 2) navigate(`/abp/projectes/${proj.id}/grups/${proj.grup}`) }}
                                                    style={{ height: '100%', borderRadius: '16px', border: `1px solid ${estat.bg}`, borderTop: `4px solid ${estat.color}`, boxShadow: '0 8px 24px rgba(0,0,0,0.04)', display: 'flex', flexDirection: 'column' }}
                                                    styles={{ body: { padding: '20px', display: 'flex', flexDirection: 'column', flex: 1 } }}
                                                >
                                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '16px' }}>
                                                        <Tag color={estat.color} style={{ borderRadius: '12px', fontWeight: 600, margin: 0 }}>{estat.text}</Tag>
                                                        <Tag color={HomeColors.colors.color3} style={{ borderRadius: '12px', margin: 0 }}><BiGroup /> {proj.grup}</Tag>
                                                    </div>

                                                    <Typography.Title level={5} style={{ margin: '0 0 8px 0', fontWeight: 700, flex: 1 }}>{proj.nom}</Typography.Title>
                                                    <Typography.Paragraph type="secondary" ellipsis={{ rows: 2 }} style={{ marginBottom: '16px', fontSize: '13px', flex: 1 }}>
                                                        {proj.descripcio || "Sense descripció"}
                                                    </Typography.Paragraph>

                                                    <div style={{ fontSize: '12px', backgroundColor: '#f8f9fa', padding: '12px', borderRadius: '8px', marginBottom: '16px' }}>
                                                        <div>📅 <b>Inici:</b> {proj.data_ini || "a determinar..."}</div>
                                                        <div style={{ marginTop: '4px' }}>⏳ <b>Fi:</b> {proj.data_fi || "a determinar..."}</div>
                                                    </div>

                                                    <div style={{ marginTop: 'auto' }}>
                                                        <Progress percent={proj.percentatge?.percentP || 0} status="active" strokeColor={HomeColors.colors.color4} strokeWidth={8} />
                                                        <div style={{ fontSize: '12px', color: '#8c8c8c', display: "flex", justifyContent: "space-between", marginTop: '8px' }}>
                                                            <span style={{ color: '#52c41a', fontWeight: 600 }}>✅ {proj.percentatge?.percentP || 0}%</span>
                                                            <span style={{ color: '#ff4d4f', fontWeight: 600 }}>❌ {proj.percentatge?.percentNP || 0}%</span>
                                                        </div>
                                                    </div>
                                                </Card>
                                            </motion.div>
                                        </Col>
                                    );
                                })}
                            </Row>
                        </motion.div>
                    )}
                </div>
            )}

            {/* MODALES */}
            {modalVisible && (
                <DudaTextoModal
                    copypaste={copypaste}
                    visible={modalVisible}
                    onClose={() => setModalVisible(false)}
                    loading={modalLoading}
                    onSubmit={async (text: string) => {
                        if (modalAula) {
                            setModalLoading(true);
                            await entrarEnCua(modalAula, text);
                            setModalLoading(false);
                            setModalVisible(false);
                        }
                    }}
                />
            )}

            {chatVisible && (
                <ChatModal
                    modalVisible={chatVisible}
                    setModalVisible={() => closeModal()}
                    onClose={() => closeModal()}
                    selectedRecord={selectedRecord}
                    hideVereCodi={true}
                    fromWelcome={true}
                    dudasEnabled={dades.find((a: any) => a.id === selectedRecord?.id_aula)?.dudas === 1}
                    isEnCua={profRequests.map(String).includes(String(selectedRecord?.id_aula))}
                    onProfRequest={() => setProfRequests(prev => [...prev, String(selectedRecord?.id_aula)])}
                    onExitQueue={(estat) => {
                        const aulaId = selectedRecord?.id_aula;
                        const aula = dades.find((a: any) => a.id === aulaId);
                        if (aula) {
                            sortirDeCua(aula, estat);
                        }
                    }}
                />
            )}

            {editarAula && (
                <AulaModal
                    visible={editarAula}
                    onClose={async (updated, data) => {
                        setEditarAula(false);
                        if (updated) {
                            if (selectedAula.id === 0) {
                                window.location.reload();
                            } else {
                                setDades(prev => prev.map(a => a.id === selectedAula.id ? { ...a, ...data } : a));
                            }
                        }
                        setSelectedAula(null);
                        checkDades(false);
                    }}
                    alumnes={[]}
                    element={selectedAula}
                    selectedIds={[]}
                />
            )}

            {studentModalVisible && selectedAula && (
                <AulaStudentsModal
                    visible={studentModalVisible}
                    onClose={() => setStudentModalVisible(false)}
                    aulaId={selectedAula.id}
                    aulaName={selectedAula.nom}
                />
            )}

            {importModalVisible && selectedAula && (
                <AulaImportModal
                    visible={importModalVisible}
                    onClose={() => setImportModalVisible(false)}
                    aulaId={selectedAula.id}
                />
            )}

            {conversaModal && (
                <ChatTableModal
                    visible={conversaModal}
                    onClose={() => {
                        setConversaModal(false);
                        checkDades(false);
                    }}
                    aula={selectedAula}
                />
            )}

            {dubtesModal && (
                <CuaModal modalVisible={dubtesModal} setModalVisible={() => {
                    setDubtesModal(false);
                    setButtonLoading(false);
                    checkDades(false);
                }} selectedRecord={selectedAula} />
            )}

            <AulaStatsModal
                visible={statsVisible}
                onClose={() => setStatsVisible(false)}
                aula={selectedAula}
            />

            {modalRA && <RaModal id_aula={selectedAula.id} element={selectedAula} json={json}
                visible={modalRA} onClose={onCloseRA} />}

            {notesResumVisible && notesResumAula && (
                <NotesResumModal
                    visible={notesResumVisible}
                    onClose={() => { setNotesResumVisible(false); setNotesResumAula(null); }}
                    aulaId={notesResumAula.id}
                    aulaNom={notesResumAula.nom}
                    userId={userId}
                />
            )}

            <Modal
                title="Inscriu-te a un aula"
                open={inscriuModalVisible}
                onOk={inscriureAula}
                onCancel={() => setInscriuModalVisible(false)}
                confirmLoading={inscriuLoading}
                okText="Inscriure'm"
                cancelText="Cancel·lar"
            >
                <p>Introdueix la clau de registre que t'ha proporcionat el professor per accedir a l'aula:</p>
                <Input
                    placeholder="Ex: M06-A"
                    size="large"
                    value={codiAula}
                    onChange={(e) => setCodiAula(e.target.value)}
                    onPressEnter={inscriureAula}
                />
            </Modal>
        </Content>
    );
};
export default Welcome;